export default __webpack_public_path__ + "static/media/non-linear-ad-close.bb859177.svg";